import { render, staticRenderFns } from "./ClientBlock.vue?vue&type=template&id=b815e442&"
import script from "./ClientBlock.vue?vue&type=script&lang=js&"
export * from "./ClientBlock.vue?vue&type=script&lang=js&"
import style0 from "./ClientBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports